var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFamily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 58,
    viewBox: "0 0 73 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.1947 24C51.8224 27.0919 48.2035 28.486 45.1116 27.1138C42.0197 25.7416 40.6256 22.1227 41.9978 19.0308C43.37 15.9389 46.9889 14.5448 50.0808 15.917C53.1728 17.2892 54.5669 20.9081 53.1947 24Z",
    fill: "#2E57FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8057 40.1706C49.4335 43.2625 44.0242 43.862 38.7238 41.5096C33.4233 39.1573 30.2389 34.7438 31.6111 31.6519C32.9833 28.56 38.3926 27.9604 43.693 30.3128C48.9934 32.6652 52.1779 37.0786 50.8057 40.1706Z",
    fill: "#2E57FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5948 25.0646C54.9784 26.4534 54.0447 27.6024 52.9169 28.4642C53.149 28.6236 53.3993 28.7642 53.6665 28.8828C55.929 29.8869 58.5482 28.9316 59.5169 26.749C60.4855 24.5664 59.4367 21.9831 57.1743 20.9791C56.8904 20.8531 56.6009 20.7579 56.3098 20.6922C56.4478 22.1394 56.2265 23.6411 55.5948 25.0646Z",
    fill: "#2E57FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9246 44.5392C53.1056 45.6979 56.2775 45.0964 57.1827 43.057C58.0794 41.0364 56.4338 38.3116 53.492 36.7232C53.8809 38.1733 53.8749 39.7249 53.2046 41.2352C52.5132 42.7932 51.3149 43.8564 49.9246 44.5392Z",
    fill: "#2E57FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5210_7519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0541 18.8042C31.7455 21.7337 30.7418 25.4797 27.8122 27.1711C24.8827 28.8624 21.1367 27.8587 19.4453 24.9292C17.7539 21.9996 18.7577 18.2536 21.6872 16.5623C24.6168 14.8709 28.3628 15.8746 30.0541 18.8042Z",
    fill: "#97ABFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7178 30.2566C43.4092 33.1861 40.7091 37.9115 35.687 40.811C30.6649 43.7105 25.2226 43.6861 23.5312 40.7566C21.8399 37.827 24.5399 33.1016 29.562 30.2021C34.5841 27.3027 40.0264 27.327 41.7178 30.2566Z",
    fill: "#97ABFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1689 22.3458C15.4379 22.1906 15.7157 22.0654 15.9982 21.9692C16.014 23.4229 16.3928 24.8928 17.1715 26.2415C17.9312 27.5574 18.9811 28.6013 20.1937 29.339C19.9798 29.5221 19.7457 29.6884 19.4925 29.8345C17.3489 31.0722 14.6433 30.399 13.4494 28.3311C12.2555 26.2631 13.0253 23.5835 15.1689 22.3458Z",
    fill: "#97ABFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8686 45.0076C23.4138 44.4756 22.1099 43.5451 21.2576 42.0689C20.4314 40.6379 20.2615 39.0956 20.4948 37.6125C17.7375 39.503 16.3892 42.3865 17.4945 44.3009C18.6101 46.2333 21.8279 46.4961 24.8686 45.0076Z",
    fill: "#97ABFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3275 17.4918C33.0872 18.8076 33.4663 20.2388 33.4989 21.6578C33.7643 21.5641 34.0254 21.4446 34.2786 21.2984C36.4222 20.0608 37.1921 17.3811 35.9981 15.3131C34.8042 13.2452 32.0986 12.5721 29.955 13.8097C29.686 13.965 29.4387 14.1429 29.2142 14.3396C30.4652 15.08 31.5488 16.143 32.3275 17.4918Z",
    fill: "#97ABFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7308 33.5407C47.5402 31.6516 48.9215 28.7336 47.8059 26.8012C46.7006 24.8868 43.5293 24.6127 40.5134 26.0554C41.9144 26.5948 43.1651 27.5131 43.9913 28.9442C44.8436 30.4203 44.9975 32.0149 44.7308 33.5407Z",
    fill: "#97ABFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5210_7519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0 21) rotate(-30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamily);
export default __webpack_public_path__ + "static/media/family.65cc8cfd6f4f8dffbf0c22c966962758.svg";
export { ForwardRef as ReactComponent };